<template>
  <div>
    <v-row>
      <v-col cols="7">
        Has this relative had genetic testing for a health condition that you know of?
        <v-radio-group
          v-model="data[modifyIndex].isgeneticTest"
          true-value="true"
          false-value="false">
          <v-radio
            label="Yes"
            :value="true"></v-radio>
          <v-radio
            label="No"
            :value="false"></v-radio>
        </v-radio-group>
      </v-col>
      <v-col cols="5">
      <div
        v-show='data[modifyIndex].isgeneticTest'>
        Do you know their results?
          <v-text-field
          v-model="data[modifyIndex].geneticTestResult"
          
          ></v-text-field>
      </div>
      </v-col>

    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    data: Array,
    modifyIndex: Number
  },
  data: () => ({
    menu: false,
  })
};
</script>
